












import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  components: {
    FieldValidationError: () => import('@/components/FieldValidationError.vue'),
  },
})
export default class FormControl extends Vue {
  @Prop({ type: String, required: true }) rules!: string;
  @Prop({ type: String }) vid?: string;
  @Prop({ type: Boolean, default: false }) customValidation?: boolean;
  @Prop({ type: Boolean, default: false }) isStaticError?: boolean;
}
